import React from 'react';

import { CarouselInfinite, CarouselSnap } from '@/components/Carousel';
import {
  LARGE_BREAKPOINT,
  MEDIUM_BREAKPOINT,
} from '@/components/modular-grid/constants';

interface CategoryCarouselProps {
  component_type: string;
  componentToRender: React.ReactNode[];
  windowWidth: number;
  autoplay?: number;
  renderedBannerSlidesAmount: number;
  percentageWidth: number;
}

const CategoryCarousel: React.FC<CategoryCarouselProps> = ({
  component_type,
  componentToRender,
  windowWidth,
  autoplay,
  renderedBannerSlidesAmount,
  percentageWidth,
}) => {
  const isTabletScreen =
    windowWidth >= MEDIUM_BREAKPOINT.min &&
    windowWidth <= MEDIUM_BREAKPOINT.max;

  const shouldBeInfinite =
    component_type === 'banner' && windowWidth > MEDIUM_BREAKPOINT.max;

  return (
    <>
      {shouldBeInfinite ? (
        <CarouselInfinite
          specifiedSlidesAmount={renderedBannerSlidesAmount}
          autoplay={autoplay}
        >
          {componentToRender}
        </CarouselInfinite>
      ) : (
        <CarouselSnap
          visiblePartLeft={50}
          visiblePartRight={50}
          specifiedSlidesAmount={renderedBannerSlidesAmount}
          lastItemPercentageWidth={percentageWidth}
          edgeSlidesPadding={windowWidth >= LARGE_BREAKPOINT.min ? 5 : 7}
          {...(component_type === 'banner' ? { autoplay } : {})}
          isTabletScreen={isTabletScreen}
          type={component_type}
        >
          {componentToRender}
        </CarouselSnap>
      )}
    </>
  );
};

export default CategoryCarousel;
